import React, {Component, ReactNode} from 'react'
import {RouteComponentProps, withRouter} from 'react-router-dom'
import Button from './Button'

interface CardButtonProps extends RouteComponentProps {
    proceedText?: string
    cancelText?: string
    children?: ReactNode
    onProceedClick?: () => void
    onCancelClick?: () => void
}

class CardButton extends Component<CardButtonProps> {
    constructor(props: CardButtonProps) {
        super(props)
        this.handleCancelClick = this.handleCancelClick.bind(this)
    }

    get cancelButton() {
        const {cancelText} = this.props
        return cancelText &&
            <Button
                type="secondary"
                text={cancelText}
                onClick={this.handleCancelClick}/>
    }

    get proceedButton() {
        const {proceedText, onProceedClick} = this.props
        return proceedText && onProceedClick &&
            <Button
                text={proceedText}
                onClick={onProceedClick}/>
    }

    // handleCancelClick() {
    //     this.props.history.goBack()
    // }

    handleCancelClick() {
        if (this.props.onCancelClick) {
            this.props.onCancelClick()
        } else {
            this.props.history.goBack()
        }
    }


    render() {
        return (
            <div className="flex justify-end mt-1 gap-4">
                {this.cancelButton}
                {this.proceedButton}
                {this.props.children}
            </div>
        )
    }
}

export default withRouter(CardButton)
